<template>
	<label ref="field" :class="size">
		<span v-if="label">{{ label }}</span>

		<input v-if="mask"
			type="date"
			:ref="refer"
			:name="name"
			:value="value"
			v-mask="mask"
			:class="design"
			@input="onInput"
			@focus="clearError"
			@blur="onBlur"
			@reset="onReset"
			@submit="onSubmit"
			@select="onSelect" />

		<input v-else
			type="date"
			:ref="refer"
			:name="name"
			:value="value"
			:class="design"
			@input="onInput"
			@focus="clearError"
			@blur="onBlur"
			@reset="onReset"
			@submit="onSubmit"
			@select="onSelect" />
	</label>
</template>

<script>
	import { mask } from 'vue-the-mask'

	export default {
		name: 'ui-input',
		directives: { mask },
		props: {
			/**
			 * Utilize para aplicar as o texto da label
			 */
			label: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para referenciar a label a um input
			 */
			refer: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para colocar um nome no input
			 */
			name: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para acessar o valor do input
			 */
			value: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para aplicar alterar entre os estilos de input
			 */
			design: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para aplicar mask no input
			 */
			mask: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para alterar o tamanho do input
			 */
			size: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para remover a mensagem de erro ao receber foco
			 */
			clearErrorOnFocus: {
				type: Boolean,
				required: false,
				default: true,
			},
		},
		methods: {
			onInput(event) {
				this.$emit('input', event.target.value)
			},
			toLocalDate(date) {
				return new Date(date).toLocaleDateString()
			},
			onFocus(event) {
				/* Comportamento padrão do input ao receber foco */
				if (this.clearErrorOnFocus) {
					this.clearError()
				}
				this.$emit('focus', event.target.value)
			},
			onBlur(event) {
				this.$emit('blur', event.target.value)
			},
			onReset(event) {
				this.$emit('reset', event.target.value)
			},
			onSubmit(event) {
				this.$emit('submit', event.target.value)
			},
			onSelect(event) {
				this.$emit('select', event.target.value)
			},
			clearError() {
				this.$refs.field.classList.remove('error')
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
